import { useMemo } from 'react';

import { useGetFace } from '@vlabs/api/luna-api/client';
import type { FaceId } from '@vlabs/api/luna-api/model';
import { buildTestid } from '@vlabs/monokit/shared/lib/utils';
import { FaceSample } from '@vlabs/uikit';
import type { WithDataTestid } from '@vlabs/uikit/types';

export interface FaceCellProps extends WithDataTestid {
  faceId: FaceId;
}

const displayName = 'FaceCell';
const testid = buildTestid(displayName);

function FaceCell({
  faceId,
  'data-testid': dataTestId = undefined,
}: FaceCellProps): React.JSX.Element {
  const getFace = useGetFace(faceId, {
    targets: ['avatar', 'face_id'],
  }, {
    query: { enabled: !!faceId },
  });
  const faceAvatarUrl = useMemo(() => {
    if (getFace.status !== 'success') return undefined;
    if (!getFace.data.avatar) return undefined;
    return `/api/lp5${getFace.data.avatar}`;
  }, [getFace.data, getFace.status]);

  if (getFace.isFetching) {
    return (
      <div
        className="BaseSampleSkeleton"
        style={{ width: 72, height: 72 }}
      />
    );
  }

  return (
    <FaceSample
      {...testid(dataTestId)}
      size="small"
      src={faceAvatarUrl}
    />
  );
}

FaceCell.displayName = displayName;

export { FaceCell };
